import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatRadioChange } from '@angular/material';
import { Router } from '@angular/router';
import { AppRoute } from 'app/app-layout/constants';
import { SiteSupportedLanguageInterface } from 'app/site-settings/models/site-supported-language.model';

import { SiteSettingsService } from 'app/site-settings/services/site-settings.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'cz-extend-logout-dialog',
  templateUrl: './extend-logout-dialog.component.html',
  styleUrls: ['./extend-logout-dialog.component.scss'],
})
export class ExtendLogoutDialogComponent implements OnInit, OnDestroy {
  public readonly logoutRoute: string = AppRoute.logout;
  public state: number = 1;
  private readonly destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { languages: SiteSupportedLanguageInterface[], defaultLanguage: number, oldDefault:number },
    private _siteSettingsService: SiteSettingsService,
    private _formBuilder: FormBuilder,
    private readonly router: Router,
    private dialogRef: MatDialogRef<ExtendLogoutDialogComponent>) {

  }

  public ngOnInit():void  {

  }
  public onExtendClicked():void {
    localStorage.setItem('activeSessionTime', ''+ new Date());
    localStorage.setItem('isExtendedPopupVisible', 'no');
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
  public getState(event: MatRadioChange): void {
    this.state = event.value;
  }
  public logout() {
    this.router.navigateByUrl(this.logoutRoute);
  }

}
